import { Spin, Skeleton } from 'antd';
import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export default function useLoading() {
  return useContext(LoadingContext);
}

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [skeleton, setSkeleton] = useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading, skeleton, setSkeleton }}>
      {skeleton? <Skeleton style={{position:'fixed'}} active/>: loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw', // Set width and height to cover the entire viewport
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(0, 0, 0, 0.1)', // Increase opacity to make it more visible
            zIndex: 9999,
          }}>
          <Spin size='large' />
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
}
